import {
  Row,
  Column,
  Container,
  Heading,
  ActionBar,
  useApi,
} from "lcm-iot-commons";

import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import TenantForm from "./TenantForm";

export default function TenantEdit() {
  const api = useApi();
  const intl = useIntl();
  const { id } = useParams<{ id: string }>();

  const { data: tenant, isLoading: isLoadingTenant } = api.get.useQuery(
    `/tenants/${id}`,
    {
      enabled: !!id,
    },
  );

  return (
    !isLoadingTenant && (
      <Container>
        <Row>
          <Column>
            <ActionBar>
              <Heading
                title={intl.formatMessage({ id: "tenant_edit.header" })}
                id="tenant-edit-header"
              />
            </ActionBar>
          </Column>
        </Row>
        <Row>
          <Column>
            <h2>{intl.formatMessage({ id: "tenant_edit.details" })}</h2>
            <TenantForm
              edit
              tenant={tenant as $TSFixMe}
              isLoadingTenant={!tenant}
            />
          </Column>
        </Row>
      </Container>
    )
  );
}
